import { filter } from "fuzzaldrin";
import { v4 as uuid } from "uuid";
import _ from "underscore";

export const isDuplicate = (newValue, existingValues) => {
  return existingValues.some((keyword) => {
    return keyword.keyword === newValue;
  });
};

export const fuzzyFilter = (searchValue, data, keyName) => {
  if (!data) return [];
  else return filter(data, searchValue, { key: keyName });
};

export const resolveKeywordsFilter = async (
  clientKeywords,
  clientKeywordsSlim,
  clientKeywordsFiltered,
  slimKeywordsFiltered,
  getKeywordsByIds,
  rowsPerPage,
  listEvents
) => {
  if (
    clientKeywordsFiltered.length === clientKeywords.length &&
    slimKeywordsFiltered.length === clientKeywordsSlim.length
  ) {
    return clientKeywords;
  }

  if (
    clientKeywordsFiltered.length === 0 &&
    slimKeywordsFiltered.length === 1
  ) {
    const keywordIds = _.pluck(slimKeywordsFiltered, "keywordID").map(
      (el) => +el
    );

    return await new Promise((resolve, rej) => {
      getKeywordsByIds({ keywordIds, listEvents }, (err, { clientKeywords }) =>
        err ? rej(err) : resolve(clientKeywords)
      );
    });
  }

  if (
    clientKeywordsFiltered.length === 0 &&
    slimKeywordsFiltered.length === 0
  ) {
    return [];
  }

  if (clientKeywordsFiltered.length === slimKeywordsFiltered.length) {
    return clientKeywordsFiltered;
  }

  const keywordIds = _.pluck(
    slimKeywordsFiltered.slice(0, rowsPerPage),
    "keywordID"
  ).map((el) => +el);

  return await new Promise((resolve, rej) => {
    getKeywordsByIds({ keywordIds, listEvents }, (err, { clientKeywords }) =>
      err ? rej(err) : resolve(clientKeywords)
    );
  });
};

export const resolveKeywordUpdate = async (
  newPage,
  newRowsPerPage,
  listEvents,
  type,
  numToDelete,
  searchTerm,
  setSearchTerm,
  getKeywordsSlim,
  setClientKeywordsSlim,
  meta,
  keywordRequestBody,
  setKeywordRequestBody,
  renderedKeywords,
  clientKeywords,
  actions,
  store
) => {
  // If a user is paginating and they have a search term then don't make any calls // REFACTOR: disable the pagination buttons when you have a search term
  if (type === "pagination" && searchTerm.trim() !== "") return;

  if (searchTerm.trim() !== "") setSearchTerm("");

  // only want to make the slim call for keywords if we have updated state with a crud action
  if (type === "create" || type === "delete" || type === "edit") {
    const slimKeywords = await getKeywordsSlim();
    setClientKeywordsSlim(slimKeywords);
  }

  // handles paginating to the last page when we create a keyword that exceeds the rowsPerPage bounds
  if (type === "create" && renderedKeywords.length === newRowsPerPage) {
    const totalPagesAfterCreating = Math.ceil(
      (meta.count + 1) / newRowsPerPage
    );

    return actions.get(
      {
        requestID: uuid(),
        resultPage: totalPagesAfterCreating, // not 0 based
        resultMax: newRowsPerPage,
        listEvents,
      },
      (err, res) => {
        store.set({ data: res, isResolving: false });
        setKeywordRequestBody({
          ...keywordRequestBody,
          page: totalPagesAfterCreating - 1, // 0 based
        });
      }
    );
  }

  const totalPages = Math.ceil(meta.count / newRowsPerPage);

  // covers the case where the user deletes all the keywords on the last page of keywords
  if (
    type === "delete" &&
    newPage + 1 === totalPages && // on the last page
    newPage !== 0 && // not on the first page
    renderedKeywords.length - numToDelete === 0 // is trying to delete all keywords
  ) {
    setKeywordRequestBody({ ...keywordRequestBody, page: newPage - 1 }); // 0 based

    return actions.get(
      {
        requestID: uuid(),
        resultPage: newPage, // not 0 based
        resultMax: newRowsPerPage,
        listEvents,
      },
      (err, res) => store.set({ data: res, isResolving: false })
    );
  }

  if (
    _.isEqual(renderedKeywords, clientKeywords) ||
    clientKeywords.length === 0
  ) {
    return actions.get(
      {
        requestID: uuid(),
        resultPage: newPage + 1,
        resultMax: newRowsPerPage,
        listEvents,
      },
      (err, res) => store.set({ data: res, isResolving: false })
    );
  }

  if (listEvents) {
    // check through all rendered keywords and only make request if there is one or more rendered keywords with an assocEventCount count
    const hasAssociatedEvents = _.compact(
      _.pluck(renderedKeywords, "assocEventCount")
    );

    if (!(hasAssociatedEvents.length > 0)) return;

    const keywordIds = _.pluck(renderedKeywords, "keywordID").map((el) => +el);

    return actions.getKeywordsByIds(
      { keywordIds, listEvents },
      (err, { clientKeywords }) => {
        setRenderedKeywords(clientKeywords);
      }
    );
  }
};
